import * as React from "react";
const SvgIcArrowUp = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M10.9 16.6H9.234v-10l-3.992 3.992a.837.837 0 0 1-1.183-1.184L10.067 3.4l6.008 6.008a.837.837 0 1 1-1.183 1.184L10.9 6.6v10Z" /></svg>;
export default SvgIcArrowUp;